import {AuthUserModel} from "@/app/api/auth";

export enum YesOrNotEnum {
  YES = 'true',
  NO = 'false',
}

export namespace YesOrNotEnum {
  export const values = Object.values(YesOrNotEnum)
    .filter(v => true) as YesOrNotEnum[];
}

export enum SkillLevelEnum {
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced',
}

export namespace SkillLevelEnum {
  export const values = Object.values(SkillLevelEnum)
    .filter(v => true) as SkillLevelEnum[];
}

export enum GenderEnum {
  MALE = 'male',
  FEMALE = 'female',
  NOT_BINARY = 'nonBinary',
}

export namespace GenderEnum {
  export const values = Object.values(GenderEnum)
    .filter(v => true) as GenderEnum[];
}

export enum MemberOfPadelClubEnum {
  YES = 'yes',
  YES_I_USED = 'usedToBeMember',
  NO = 'no',
}

export namespace MemberOfPadelClubEnum {
  export const values = Object.values(MemberOfPadelClubEnum)
    .filter(v => true) as MemberOfPadelClubEnum[];
}

export enum PlayingDurationEnum {
  LESS_ONE_YEAR = 'lessThan1Year',
  ONE_FIVE_YEARS = 'oneToFiveYears',
  MORE_THEN_FIVE_YEARS = 'moreThanFiveYears',
}

export namespace PlayingDurationEnum {
  export const values = Object.values(PlayingDurationEnum)
    .filter(v => true) as PlayingDurationEnum[];
}

export enum NprpRatingEnum {
  BEGINNER_RATING = 'beginnerRange',
  INTERMEDIATE_RATING = 'intermediateRange',
  ADVANCED_RATING = 'advancedRange',
}

export namespace NprpRatingEnum {
  export const values = Object.values(NprpRatingEnum)
    .filter(v => true) as NprpRatingEnum[];
}

export enum PlayingFrequencyEnum {
  ALMOST_DAILY = 'almostDaily',
  THREE_TO_FOUR_TIMES_A_WEEK = 'threeToFourTimesAWeek',
  ONE_TO_TWO_TIMES_A_WEEK = 'oneToTwoTimesAWeek',
  WEEKLY = 'weekly',
  A_FEW_TIMES_A_MONTH = 'aFewTimesAMonth',
  RARELY = 'rarely',
}

export namespace PlayingFrequencyEnum {
  export const values = Object.values(PlayingFrequencyEnum)
    .filter(v => true) as PlayingFrequencyEnum[];
}

export enum IndustryEnum {
  TECHNOLOGY = 'technology',
  HEALTHCARE = 'healthcare',
  EDUCATION = 'education',
  MARKETING = 'marketing',
  FINANCE = 'finance',
  ENERGY = 'energy',
  HOSPITALITY = 'hospitality',
  INSURANCE = 'insurance',
  ARTS = 'arts',
  LOGISTICS = 'logistics',
  RETAIL = 'retail',
  ENGINEERING = 'engineering',
  RESEARCH = 'research',
  SPORTS = 'sports',
  LAW = 'law',
  MEDIA = 'media',
  REAL_ESTATE = 'realEstate',
  FASHION = 'fashion',
  NONPROFIT = 'nonprofit',
}

export namespace IndustryEnum {
  export const values = Object.values(IndustryEnum)
    .filter(v => true) as IndustryEnum[];
}


export interface UserProfileModel {
  username?: string;
  imageLink?: string;
  ntrpRating?: NprpRatingEnum;
  skillLevel?: SkillLevelEnum;
  city?: string;
  gender?: GenderEnum;
  padelClubMembership?: MemberOfPadelClubEnum;
  playingDuration?: PlayingDurationEnum;
  playingFrequency?: PlayingFrequencyEnum;
  aboutYourself?: string;
  name?: string;
  industry?: string;
  instagram?: string;
  linkedin?: string;
  rocketSportsExperience?: YesOrNotEnum;
  dateOfBirth?: string;
  showDateOfBirthInProfile?: boolean;
  showGenderInProfile?: boolean;
}

export interface UserProfileModelForSend {
  username?: string;
  imageLink?: string;
  ntrpRating?: NprpRatingEnum;
  skillLevel?: SkillLevelEnum;
  city?: string;
  gender?: GenderEnum;
  padelClubMembership?: MemberOfPadelClubEnum;
  playingDuration?: PlayingDurationEnum;
  playingFrequency?: string;
  aboutYourself?: string;
  name?: string;
  industry?: string;
  instagram?: string;
  linkedin?: string;
  rocketSportsExperience?: YesOrNotEnum;
  dateOfBirth?: string;
  showDateOfBirthInProfile?: boolean;
  showGenderInProfile?: boolean;
}

export interface UserModel {
  id: number,
  user: AuthUserModel,
  username: string;
  imageLink?: string;
  ntrpRating?: NprpRatingEnum;
  skillLevel: SkillLevelEnum;
  city: string;
  gender: GenderEnum;
  padelClubMembership: MemberOfPadelClubEnum;
  playingDuration: PlayingDurationEnum;
  playingFrequency: PlayingFrequencyEnum;
  aboutYourself: string;
  industry: IndustryEnum;
  instagram: string;
  linkedin: string;
  rocketSportsExperience: YesOrNotEnum;
  dateOfBirth: string;
  showDateOfBirthInProfile: boolean;
  showGenderInProfile: boolean;
  preferredRadiusKm?: number
}

export interface UserUploadPhotoModel {
  file: string
}

export interface UserChangeGeoSettingsModel {
  available?: boolean
  skillLevel?: SkillLevelEnum
  experienceYears?: number
  playingFrequency?: PlayingFrequencyEnum
  matchesCount?: number
  preferredRadiusKm?: number
}

export interface NewUserModel {
  id: number;
  user: NewSmallUserModel;
  rocketSportsExperience?: YesOrNotEnum;
  ntrpRating?: NprpRatingEnum;
  skillLevel?: SkillLevelEnum;
  city?: string;
  gender?: GenderEnum;
  showGenderInProfile?: boolean;
  dateOfBirth?: string;
  padelClubMembership?: MemberOfPadelClubEnum;
  playingDuration?: PlayingDurationEnum;
  aboutYourself?: string;
  industry?: string;
  instagram?: string;
  linkedin?: string;
  profile?: any | null;
}

export interface NewSmallUserModel {
  id: number;
  email?: string;
  password?: string;
  username?: string;
  imageLink?: string;
  lastLat?: number;
  lastLng?: number;
  locationUpdatedAt?: string;
  available?: boolean;
  skillLevel?: SkillLevelEnum;
  experienceYears?: number;
  playFrequency?: PlayingFrequencyEnum;
  matchesCount?: number;
  preferredRadiusKm?: number;
  referrals?: number[];
  referralsCount?: number;
}

export interface NearbyUsersModel {
  id: number;
  username?: string;
  imageLink?: string;
  skillLevel?: SkillLevelEnum;
  ntrpRating?: NprpRatingEnum;
  matchesCount?: number;
  distanceKm?: number;
  playFrequency?: PlayingFrequencyEnum;
  playingDuration?: PlayingDurationEnum;
  experienceYears?: number;
  city?: string;
}

export interface UpdateUserLocationModel {
  latitude: number;
  longitude: number;
}

export interface PreordersEmailModel {
  id?: number;
  email?: string;
}

export interface NotificationModel {
  id?: number;
  userId?: number;
  userImage?: string;
  text?: string;
  timestamp?: Date;
  invitationId?: number;
}